<template>
  <div class="container" :style="{display: noAccess ? 'flex' : 'none'}">
    <div v-if="noAccess" class="warning-container">
      <p class="warning">
        This is a VRpatients development environment
        Please visit <a href="https://app.vrpatients.com">app.vrpatients.com</a>
      </p>
      <md-button class="md-raised md-accent" @click="logout">
        Logout
      </md-button>
    </div>
  </div>
</template>

<script>
import parseGroupMetadata from '~lib/common/utils/parseGroupMetadata';

export default {
  name: 'dev-environments-guard',
  props: {
    user: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    noAccess() {
      return this.isDevEnvironment && !this.hasDevAccess;
    },
    isDevEnvironment() {
      const {host} = window.location;
      return host !== 'app.vrpatients.com';
    },
    hasDevAccess() {
      if (!this.user) {
        return true;
      }
      const appMetadata = this.user['https://vrpatients.com/app_metadata'];
      const groupsData = this.user['https://vrpatients.com/groupsData'];
      const isDev = appMetadata && appMetadata.dev;
      const isInDevGroup = groupsData && groupsData.find(group => {
        const metadata = parseGroupMetadata(group);
        return metadata && metadata.dev;
      });
      return isDev || isInDevGroup;
    },
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
  }
};
</script>

<style scoped>
.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #525252;
}

.warning-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.warning {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
</style>